import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageCarryable } from '../voyageCarryable-sidecar'
import { voyageJettisons } from '../voyageJettisons-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageJettison {
  crewId: number
  carryableId: number
  x: number
  y: number
  dx: number
  dy: number
}
export const voyageMessageId = EVoyageMessage.Jettison

export function write(m: IMessageWriter, d: IMessageJettison) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.crewId)
  messageWriter.write32(m, d.carryableId)
  messageWriter.write32(m, d.x)
  messageWriter.write32(m, d.y)
  messageWriter.write32(m, d.dx)
  messageWriter.write32(m, d.dy)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageJettison = {
    crewId: messageWriter.read32(m),
    carryableId: messageWriter.read32(m),
    x: messageWriter.read32(m),
    y: messageWriter.read32(m),
    dx: messageWriter.read32(m),
    dy: messageWriter.read32(m),
  }

  return d
}

export function test() {
  let ex: IMessageJettison = {
    crewId: 100,
    carryableId: 345,
    x: 1231,
    y: 6548,
    dx: 1002,
    dy: 10,
  }
  messageWriter.test('jettison', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  if (msg.carryableId > 0) {
    let cy = voyageCarryable.findByIdSafe(msg.carryableId)
    if (!cy) {
      websockets.reportBadCommand(
        m,
        msg,
        'voyageMessage-jettison',
        'carryable-id',
      )
      return
    }

    // console.log('jettison!', msg.x, msg.y, msg.dx, msg.dy)

    voyageJettisons.create(null, cy, msg.x, msg.y, msg.dx, msg.dy)
    voyageCarryable.kill(cy)
  }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageJettison) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
